// Il taccuino «Il quaderno ha capito»: gli appunti che si vedono mentre mamma parla col
// quaderno (dialogo e telefonata). Arrivano dal turno (evento SSE `appunti`), sempre interi:
// ogni volta si ridisegna tutto, niente stato da tenere allineato.
import { el } from './ui.js';

type Appunti = { persone?: Array<{ nome: string; nota: boolean }>; luoghi?: string[]; anni?: string[] };

export function taccuino(): { element: HTMLElement; aggiorna: (d: Record<string, unknown>) => void } {
  const corpo = el('div', { class: 'appunti-voci' });
  // Non «aria-live»: rileggere tutto il taccuino a ogni turno coprirebbe la voce del quaderno.
  const element = el('section', { class: 'appunti', 'aria-label': 'Il quaderno ha capito', hidden: '' },
    el('p', { class: 'appunti-titolo' }, 'Il quaderno ha capito'), corpo,
    el('p', { class: 'appunti-aiuto' }, 'Se qualcosa non va, dillo pure: «No, era…»'));
  const voce = (testo: string, classe: string, titolo: string): HTMLElement => el('span', { class: `appunti-voce ${classe}`, title: titolo }, testo);
  return {
    element,
    aggiorna(d) {
      const a = d as Appunti;
      const voci = [
        ...(a.persone ?? []).map((p) => voce(p.nome, p.nota ? 'is-nota' : 'is-nuova', p.nota ? 'Una persona già nel tuo albero' : 'Un nome nuovo')),
        ...(a.luoghi ?? []).map((l) => voce(l, 'is-luogo', 'Un luogo')),
        ...(a.anni ?? []).map((y) => voce(y, 'is-anno', 'Un anno')),
      ];
      corpo.replaceChildren(...voci);
      element.hidden = voci.length === 0;
    },
  };
}
